// extracted by mini-css-extract-plugin
export var label = "_dt-2";
export var slideContainer = "_dt-0";
export var slider = "_dt-1";